// extracted by mini-css-extract-plugin
export default {"container":"micromag_container__2sRwo"};